angular.module('iqxCore')
.controller('actionDialogMakeContactCtrl', function ($scope, FormSvc, ApplicationSvc, ApiSvc) {
    $scope.noContactDetails=false
    $scope.selects={}
    $scope.selects.contacts=[]

    FormSvc.setOptions($scope,{
        fetchAPI:'callresult/NetOwnerActionDialog?pObjectID='+$scope.actiondialogparams.linkID,
        fetchTarget:'actions',
        multiRow:true
    })

    if ($scope.actiondialogparams.type=="Company") {
        $scope.companyID=$scope.actiondialogparams.linkID
        $scope.fetch({
            fetchAPI:'callresult/NetOwnerContactList?pCompanyID='+$scope.actiondialogparams.linkID,
            fetchTarget:'companyContacts',
            multiRow:true
        })
        .then(function(){
            $scope.companyContacts.push({"Value":$scope.companyID, "Descrip":"Company: " + $scope.itemSummary.name})
        })
    }

    $scope.reFetchContactDetails=function(contact){
        $scope.fetch({
            fetchAPI:'callresult/NetOwnerActionDialog?pObjectID='+contact.Value,
            fetchTarget:'actions',
            multiRow:true
        })
        .then(function(){
            $scope.showContactDetails()
        })
    }

    $scope.showContactDetails=function(){
        if(!$scope.actions[0].number){
            $scope.noContactDetails=true
        } else {
            $scope.name=$scope.itemSummary.name
        }
    }

    $scope.contactAction=function(action, details){
        // if sendSMSviaIQX switch is on, do that here - no need for contact event
        if (action=='sms' && $scope.userHasRight('SMSVIAIQX')) {
            FormSvc.modalForm($scope,'sendsms',{},'md',{label:'col-sm-3', data:'col-sm-7'})
                .then(function(r) {
                    $scope.fetch({
                        fetchAPI:'callresult/NetSendMessageToCandidate?pRecipientID='+$scope.actiondialogparams.linkID+'&pMessageText='+r.smsMessage,
                        fetchTarget:'smsReturn',
                        multiRow:false
                    })
                    .then(function(){
                        if ($scope.smsReturn.pResult == '0:~Success') {
                            FormSvc.alert("SMS Sent", "Your SMS message has been added to the queue to be sent shortly.", "success")
                        } else {
                            FormSvc.alert("SMS Failed", $scope.smsReturn.pResult, "error")
                        }
                    })
                })
        } else {
            window.location.href=action+":"+details
            $scope.set_actionView('views/actionDialog.makeContactEvent.html', 'Make Contact Event')
        }
    }

    $scope.goBack=function(){
        $scope.ActionDialogBody = undefined
    }

    $scope.fetch()
    .then(function(){
        $scope.showContactDetails()
    })
})
